'use strict';

import afterHoursLeaderModule from './after-hours-leader';
import buppAppointmentModule from './bupp-appointment';
import buppQuestionnaireModule from './bupp-questionnaire';

const MODULE_NAME = 'daupler.entities.jcw';

var app = angular.module(MODULE_NAME, [
	afterHoursLeaderModule,
	buppAppointmentModule,
	buppQuestionnaireModule,
]);

export default MODULE_NAME;
